import { Stack } from '@mui/system';
import { ReactComponent as BriefcaseCheckIcon } from '../../../../assets/icons/layout-icons/BriefcaseCheckIcon.svg';
import { Typography } from '@mui/material';
import { WithdrawModalType } from '../../pitch.interface';
import { secondaryBlue } from '../../../../utils/color';
import CustomButton from '../../../../components/button/CustomButton';
import useUpdate from '../../../../utils/hooks/crud-hooks/useUpdate';
import { useRefresh } from '../../../../utils/hooks/crud-hooks/useRefresh';
import CustomModal from '../../../../components/modal/CustomModal';

const WithdrawModal = ({ open, setOpen, pitchId }: WithdrawModalType) => {
  const refresh = useRefresh();
  const { mutate: withdraw } = useUpdate({
    resource: '/timed-project-pitches',
  });

  const handleWithdraw = () => {
    withdraw(
      {
        id: pitchId,
        suffix: 'withdraw-pitch',
      },
      {
        onSuccess: () => {
          refresh();
          setOpen(false);
        },
      },
    );
  };

  return (
    <CustomModal open={open} onClose={() => setOpen(false)}>
      <Stack direction="column">
        <Stack direction="row" alignItems="center" mb={3}>
          <Stack
            width={40}
            height={40}
            mr={2}
            bgcolor="secondaryBlue.100"
            borderRadius={1}
            justifyContent="center"
            alignItems="center"
          >
            <BriefcaseCheckIcon width="20px" fill={secondaryBlue[700]} />
          </Stack>
          <Typography variant="heading4" color="primaryDark.600">
            withdraw pitch
          </Typography>
        </Stack>
        <Stack
          py={2}
          sx={{
            borderTop: `1px solid ${secondaryBlue[100]}`,
            borderBottom: `1px solid ${secondaryBlue[100]}`,
          }}
        >
          <Typography color="primaryDark.500" variant="body2">
            Your request to withdraw your pitch will be submitted to Spona. Both parties will be
            notified once the request has been successfully processed.
          </Typography>
        </Stack>
        <Stack direction="row" gap={3} mt={2} justifyContent="flex-end">
          <CustomButton onClick={() => setOpen(false)} variant="secondary">
            Cancel
          </CustomButton>
          <CustomButton onClick={handleWithdraw} variant="primary">
            Submit
          </CustomButton>
        </Stack>
      </Stack>
    </CustomModal>
  );
};

export default WithdrawModal;
